<template>
<div>
<h3>Согласие с условиями обработки персональных данных при регистрации на сайте cdsvyatka.com</h3>
<p>
  Заполняя регистрационную форму и нажимая кнопку «Продолжить», я подтверждаю,
  что являюсь законным представителем моего ребенка (детей) при осуществлении его (их) прав
  и интересов в рамках договора-оферты на оказание услуг по безналичной оплате проезда
  в автомобильном и электрифицированном транспорте общего пользования (кроме такси),
  безналичной оплате школьного питания в образовательных организациях, а также по проходу
  в учебные и другие заведения, оснащенные автоматизированной системой контроля доступа,
  размещенного на сайте по адресу: cdsvyatka.com (далее - Договор), заключенного между мной
  и муниципальным бюджетным учреждением «Центральная диспетчерская служба городского
  пассажирского транспорта» (адрес места нахождения: 610004, г. Киров, ул. Пятницкая, д.2а, далее
  – МБУ «ЦДС ГПТ», Оператор), и в соответствии со статьей 9 Федерального закона от 27.07.2006 №
  152-ФЗ «О персональных данных» даю согласие Оператору на обработку отправляемых мной через
  сеть Интернет сведений в целях оказания следующих услуг:
</p>
<p>
  <ul>
    <li> - регистрация на сайте cdsvyatka.com;</li>
    <li> - управление электронной картой через Личный кабинет Гражданина на сайте по адресу: cdsvyatka.com;</li>
    <li> - предоставление сервиса уведомлений о балансе, о проходах через автоматизированную систему контроля доступа;</li>
    <li> - информирование о маркетинговых акциях, конкурсах и иных подобных мероприятиях, проводимых Оператором.</li>
  </ul>
</p>
<p>
  1. Данное согласие дается на обработку следующих моих персональных данных:
  контактный телефон, контактный адрес электронной почты.
</p>
<p>
  2. Данное согласие дается на обработку следующих персональных данных моего ребенка
  (детей): фамилия, имя, отчество, наименование образовательной организации и класса,
  номер электронной карты; информация о балансе счетов электронной карты;
  информация о проходах через автоматизированную систему контроля доступа.
</p>
<p>
  3. Данное согласие дается мною на автоматизированную, а также без использования
  средств автоматизации обработку моих персональных данных и персональных данных
  моего ребенка (детей), включая сбор, запись, систематизацию, накопление, хранение,
  уточнение (обновление, изменение), извлечение, использование, передачу (предоставление),
  блокирование, удаление, уничтожение персональных данных.
</p>
<p>
  4. Данное согласие дается на предоставление моих персональных данных и персональных
  данных моего ребенка (детей) организациям, осуществляющим свою деятельность на договорных
  условиях с МБУ «ЦДС ГПТ» и обеспечивающим надежное и безопасное функционирование
  Системы безналичной оплаты школьного питания и Личного кабинета Гражданина в порядке и
  объеме, определенными условиями соответствующих договоров и соглашений.
</p>
<p>
  5. Данное согласие действует с момента предоставления на срок обучения моего ребенка
  (детей) в образовательной организации и в течение 3 (трех) лет после истечения данного срока с
  целью завершения финансовых операций (в том числе возврата денежных средств со счета
  электронной карты).
</p>
<p>
  6. Данное согласие дается в целях оказания приведенных выше услуг. Данное согласие может
  быть отозвано путем подачи письменного заявления, в связи с чем дальнейшее оказание этих услуг
  будет невозможно.
</p>
<p>
  7. Я проинформирован (-а), что после отзыва данного согласия МБУ «ЦДС ГПТ» продолжит
  обработку моих персональных данных и персональных данных моего ребенка (детей),
  необходимую для осуществления прав и законных интересов МБУ «ЦДС ГПТ» или третьих лиц, а
  также для осуществления и выполнения возложенных на МБУ «ЦДС ГПТ» законодательством
  Российской Федерации обязанностей, возникших при выполнении условий Договора.
</p>
<h3>Согласие с условиями обработки персональных данных при регистрации на сайте cdsvyatka.com</h3>
<p>
  Заполняя регистрационную форму и нажимая кнопку «Продолжить», я подтверждаю,
  что являюсь владельцем электронной карты в рамках договора-оферты на оказание услуг
  по безналичной оплате проезда в автомобильном и электрифицированном транспорте общего
  пользования (кроме такси), безналичной оплате школьного питания в образовательных
  организациях, а также по проходу в учебные и другие заведения, оснащенные автоматизированной
  системой контроля доступа, размещенного на сайте по адресу: cdsvyatka.com (далее - Договор),
  заключенного между мной и муниципальным бюджетным учреждением «Центральная
  диспетчерская служба городского пассажирского транспорта» (адрес места нахождения: 610004,
  г. Киров, ул. Пятницкая, д.2а, далее – МБУ «ЦДС ГПТ», Оператор), и в соответствии со статьей 9
  Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» даю согласие Оператору
  на обработку отправляемых мной через сеть Интернет сведений в целях оказания следующих услуг:
</p>
<p>
  <ul>
    <li> - регистрация на сайте cdsvyatka.com;</li>
    <li> - управление электронной картой через Личный кабинет Гражданина на сайте по адресу: cdsvyatka.com;</li>
    <li> - предоставление сервиса уведомлений о балансе, о проходах через турникет в учебных и других заведениях,
      оснащенных автоматизированной системой контроля доступа;
    </li>
    <li> - информирование о маркетинговых акциях, конкурсах и иных подобных мероприятиях, проводимых МБУ «ЦДС ГПТ».</li>
  </ul>
</p>
<p>
  1. Данное согласие дается на обработку следующих моих персональных данных: фамилия,
  имя, отчество, номер электронной карты, наименование образовательной организации и должность,
  контактный телефон, контактный адрес электронной почты, информация о балансе счетов
  электронной карты, информация о проходах через автоматизированную систему контроля доступа.
</p>
<p>
  2.  Данное согласие дается мною на автоматизированную, а также без использования средств
  автоматизации обработку моих персональных данных, включая сбор, запись, систематизацию,
  накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу
  (предоставление), блокирование, удаление, уничтожение персональных данных.
</p>
<p>
  3. Данное согласие дается на предоставление моих персональных данных организациям,
  осуществляющим свою деятельность на договорных условиях с МБУ «ЦДС ГПТ»
  и обеспечивающим надежное и безопасное функционирование Системы безналичной оплаты
  школьного питания и Личного кабинета Гражданина в порядке и объеме, определенными
  условиями соответствующих договоров и соглашений.
</p>
<p>
  4. Данное согласие действует с момента предоставления на срок работы в образовательной
  организации и в течение 3 (трех) лет после истечения данного срока с целью завершения
  финансовых операций (в том числе возврата денежных средств со счета электронной карты)
</p>
<p>
  5. Данное согласие дается в целях оказания приведенных выше услуг. Данное согласие может
  быть отозвано путем подачи письменного заявления, в связи с чем дальнейшее оказание этих услуг
  будет невозможно.
</p>
<p>
  6. Я проинформирован (-а), что после отзыва данного согласия МБУ «ЦДС ГПТ» продолжит
  обработку моих персональных данных, необходимую для осуществления прав и законных
  интересов МБУ «ЦДС ГПТ» или третьих лиц, а также для осуществления и выполнения
  возложенных на МБУ «ЦДС ГПТ» законодательством Российской Федерации обязанностей,
  возникших при выполнении условий Договора.
</p>
</div>
</template>

<script>
export default {
  name: 'contract-offer'
}
</script>

<style lang="css">
</style>
